import { render, staticRenderFns } from "./ArticleList.vue?vue&type=template&id=0dd85b82&scoped=true&"
import script from "./ArticleList.vue?vue&type=script&lang=js&"
export * from "./ArticleList.vue?vue&type=script&lang=js&"
import style0 from "./ArticleList.vue?vue&type=style&index=0&id=0dd85b82&lang=scss&scoped=true&"
import style1 from "./ArticleList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd85b82",
  null
  
)

export default component.exports